/* @flow */
import React, { memo, useEffect, useState } from 'react';
import { Alert, Spin, Typography } from 'antd';

type Props = {
  fileUrl: string,
};

const TxtViewer = ({ fileUrl }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFile = async () => {
      setLoading(true);
      try {
        const response = await fetch(fileUrl);
        const text = await response.text();
        setData(text);
        setLoading(false);
        setError(null);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    };

    fetchFile();
  }, [fileUrl]);

  const renderContent = () => {
    if (!error) {
      if (loading) {
        return <Spin />;
      } else {
        return <Typography.Text>{data}</Typography.Text>;
      }
    } else {
      return <Alert message="Error" description="Some error has occurred. Please try again." type="error" showIcon />;
    }
  };

  return <div style={{ whiteSpace: 'pre-wrap' }}>{renderContent()}</div>;
};

const TxtViewerMemo = memo<Props>(TxtViewer);

export default TxtViewerMemo;
